export const mockData = {
  company: {
    name: "Varun Solar Energy",
    tagline: "Powering Tomorrow with Clean Energy Today",
    phone: "+91 96962 52549",
    phone2: "+91 97959 84540",
    email: "varunsolarenergyprayagraj@gmail.com",
    address: "110A, Chak Trivenipuram Jhunsi, Prayagraj, Uttar Pradesh 211019",
    socialMedia: {
      facebook: "https://facebook.com/p/Varun-Solar-Energy-61566361151186/",
      youtube: "https://www.youtube.com/channel/UC6CD1pf3yCl9u-f_F-RsBIQ",
      instagram: "#",
      twitter: "#",
      linkedin: "#"
    }
  },
  
  hero: {
    title: "Transform Sunlight Into Savings",
    subtitle: "Leading provider of solar energy solutions for homes, businesses, and industries",
    cta: "Get Free Quote"
  },
  
  about: {
    title: "About Varun Solar Energy",
    description: "With years of experience in renewable energy, Varun Solar Energy has been at the forefront of India's solar revolution. We are committed to providing high-quality, efficient, and affordable solar solutions that help you reduce energy costs while protecting our environment.",
    mission: "Our mission is to make clean, renewable energy accessible to everyone while contributing to a sustainable future.",
    stats: [
      { number: "500+", label: "Projects Completed" },
      { number: "50MW+", label: "Total Capacity Installed" },
      { number: "1000+", label: "Happy Customers" },
      { number: "15+", label: "Years Experience" }
    ]
  },
  
  services: {
    installation: [
      {
        id: 1,
        title: "Residential Solar Installation",
        description: "Designing and installing solar panels for homes, villas, and apartments.",
        icon: "home"
      },
      {
        id: 2,
        title: "Commercial & Industrial Solar (C&I)",
        description: "Large-scale rooftop or ground-mounted systems for factories, warehouses, hotels, and hospitals.",
        icon: "building"
      },
      {
        id: 3,
        title: "On-Grid Solar Systems",
        description: "Grid-connected systems designed to reduce electricity bills and export surplus energy.",
        icon: "zap"
      },
      {
        id: 4,
        title: "Off-Grid Solar Systems",
        description: "Independent systems utilizing battery storage for areas without grid connectivity.",
        icon: "battery"
      },
      {
        id: 5,
        title: "Hybrid Solar Systems",
        description: "Systems that combine grid connectivity with battery storage for uninterrupted power.",
        icon: "layers"
      },
      {
        id: 6,
        title: "Solar Rooftop Solutions",
        description: "End-to-end installation of photovoltaic (PV) panels on rooftops.",
        icon: "sun"
      },
      {
        id: 7,
        title: "Ground-Mounted Systems",
        description: "Installation on open land for maximum sun exposure.",
        icon: "map"
      },
      {
        id: 8,
        title: "Solar Carports/Sheds",
        description: "Dual-purpose structures that provide shade while generating power.",
        icon: "car"
      }
    ],
    engineering: [
      {
        id: 9,
        title: "Site Assessment & Survey",
        description: "Detailed analysis of roof space, orientation, and shadow coverage to optimize energy production.",
        icon: "search"
      },
      {
        id: 10,
        title: "Customized System Design",
        description: "Tailored engineering plans based on energy usage and structural requirements.",
        icon: "layout"
      },
      {
        id: 11,
        title: "Feasibility Studies & DPR",
        description: "Preparation of Detailed Project Reports (DPR) and technical feasibility studies.",
        icon: "file-text"
      },
      {
        id: 12,
        title: "Net Metering & Licensing",
        description: "Assisting with documentation and approval for grid-connected systems.",
        icon: "check-circle"
      },
      {
        id: 13,
        title: "Subsidy & Loan Assistance",
        description: "Guidance on government subsidies (e.g., PM-Surya Ghar) and financing options.",
        icon: "dollar-sign"
      }
    ],
    maintenance: [
      {
        id: 14,
        title: "Operations & Maintenance (O&M)",
        description: "Proactive monitoring and maintenance of installed solar plants.",
        icon: "settings"
      },
      {
        id: 15,
        title: "Solar Panel Cleaning",
        description: "Automated or manual cleaning services to maintain efficiency.",
        icon: "droplet"
      },
      {
        id: 16,
        title: "System Upgrades & Repair",
        description: "Troubleshooting, repairing, and upgrading existing solar components.",
        icon: "wrench"
      },
      {
        id: 17,
        title: "Performance Monitoring",
        description: "Real-time monitoring of energy generation through apps or web portals.",
        icon: "activity"
      }
    ],
    components: [
      {
        id: 18,
        title: "Solar Modules",
        description: "High-efficiency Mono PERC, Bifacial, or Poly-crystalline panels.",
        icon: "grid"
      },
      {
        id: 19,
        title: "Inverters",
        description: "Grid-tied, string, or micro-inverters for optimal energy conversion.",
        icon: "cpu"
      },
      {
        id: 20,
        title: "Battery Storage",
        description: "Solar batteries for energy storage and backup power.",
        icon: "battery-charging"
      },
      {
        id: 21,
        title: "Mounting Structures",
        description: "Durable structures for rooftop or ground, including trackers.",
        icon: "box"
      }
    ]
  },
  
  features: [
    {
      title: "Premium Quality",
      description: "High-efficiency solar panels with 25+ years warranty",
      icon: "award"
    },
    {
      title: "Expert Installation",
      description: "Professional installation by certified technicians",
      icon: "users"
    },
    {
      title: "Cost Savings",
      description: "Reduce electricity bills by up to 90%",
      icon: "trending-down"
    },
    {
      title: "24/7 Support",
      description: "Round-the-clock customer support and maintenance",
      icon: "headphones"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Homeowner",
      comment: "Varun Solar Energy transformed our home with their excellent rooftop installation. Our electricity bills have dropped by 80%!",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "Business Owner",
      comment: "The solar atta chakki has been a game-changer for our flour mill business. Zero power costs and excellent performance!",
      rating: 5
    },
    {
      id: 3,
      name: "Anil Patel",
      role: "Factory Owner",
      comment: "Professional team, quality products, and outstanding after-sales service. Highly recommend Varun Solar Energy!",
      rating: 5
    }
  ]
};
